<template>
	<div id="Mainpage">
		<HrrBreadcrumb PMname="首页" />
		<HrrMainCardLayout v-for="p in planData" >
			<template slot="custom">
				<el-row>
					<el-col :span="24"  class="console-show-plan">
						<h3>{{p.planName}}</h3>
						<el-steps :active="p.status">
							<el-step v-for="item in statusData" 
							:title="item.statusName" :icon="item.icon" :description="item.description"></el-step>
						</el-steps>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-card class="hrr-el-card" shadow="never">
							<div slot="header" class="clearfix">
							    <span>岗位类型分布图</span>
							</div>
							<ve-waterfall :data="p.RaTypeData"></ve-waterfall>
						</el-card>
					</el-col>
					<el-col :span="12">
						<el-card class="hrr-el-card" shadow="never">
							<div slot="header" class="clearfix">
							    <span>研究生报名岗位人数TOP10</span>
							</div>
							<ve-histogram :data="p.TopTenPostDeliveryData" :settings="TopTenPostDeliverySettings" ></ve-histogram>
						</el-card>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-card class="hrr-el-card" shadow="never" >
							<div slot="header" class="clearfix">
							    <span>报名人员学历分布图</span>
							</div>
							<ve-pie :data="p.EducationTypeData"></ve-pie>
						</el-card>
					</el-col>
					<el-col :span="12">
						<el-card class="hrr-el-card" shadow="never" >
							<div slot="header" class="clearfix">
							    <span>报名人员生源类型，社会招聘类型分布图</span>
							</div>
							<ve-pie :data="p.SourceAndOnJobData"></ve-pie>
						</el-card>
					</el-col>
				</el-row>
			</template>
		</HrrMainCardLayout>
	</div>
</template>
<script>
	export default {
		name:'console_mainpage',
		data(){
			this.TopTenPostDeliverySettings={
				stack:{'人数':['男','女']}
			}
			return{
				RaTypeData: {
					columns: ['raType', '岗位数'],
					rows: []
				},
				TopTenPostDeliveryData:{
					columns:['postTitle','男','女'],
					rows:[]
				},
				EducationTypeData: {
					columns: ['educationType', '人数'],
					rows: []
				},
				SourceAndOnJobData: {
					columns: ['gSourceType', 'num'],
					rows: []
				},
				statusData:[],
				planData:[]

			}
		},
		methods:{
			initPlanData(){
				this.statusData.forEach(e=>{
					var descArr=e.statusDesc.split("|");
					e.description=descArr[0];
					e.icon=descArr[1];
				});
				var Vuethis = this;
                this.$hrraxios.get(this.$api.console.getCurrentPlanList)
                .then(response=> {
                    let data = response.data;
                    if (data.success == true) {
                        data.data.forEach(function(row){
                        	row.RaTypeData={};
                        	row.RaTypeData.rows=[];
                        	row.TopTenPostDeliveryData={};
                        	row.TopTenPostDeliveryData.rows=[];
                        	row.EducationTypeData={};
                        	row.EducationTypeData.rows=[];
                        	row.SourceAndOnJobData={};
                        	row.SourceAndOnJobData.rows=[];
                    		Vuethis.initReportData(row);
                    	});
                    	Vuethis.planData = data.data;
                    }
                })
                .catch(error=>{
                });
			},
			async initReportData(DO){
				var Vuethis = this;
				//岗位类型分布图
                var res= await this.$hrraxios.get(this.$api.console.getReportbyRaType,{params:{planId:DO.planId}})
                .then(response=> {
                    let data = response.data;
                    if (data.success == true) {
                    	DO.RaTypeData.columns=Vuethis.RaTypeData.columns;
                        DO.RaTypeData.rows = data.data;
                    }else{
                    	Vuethis.$message({message:data.prompt,type:"error"});
                    }
                })
                .catch(error=>{
                	console.log(error);
                });
                //岗位报名人数TOP10
                this.$hrraxios.get(this.$api.console.getReportTopTenPostDelivery,{params:{planId:DO.planId}})
                .then(response=> {
                    let data = response.data;
                    if (data.success == true) {
                    	DO.TopTenPostDeliveryData.columns=Vuethis.TopTenPostDeliveryData.columns;
                        DO.TopTenPostDeliveryData.rows = data.data;
                    }else{
                    	Vuethis.$message({message:data.prompt,type:"error"});
                    }
                })
                .catch(error=>{
                });
                //报名人员学历分布图
                this.$hrraxios.get(this.$api.console.getReportEducationType,{params:{planId:DO.planId}})
                .then(response=> {
                    let data = response.data;
                    if (data.success == true) {
						DO.EducationTypeData.columns=Vuethis.EducationTypeData.columns;
                        DO.EducationTypeData.rows = data.data;
                    }else{
                    	Vuethis.$message({message:data.prompt,type:"error"});
                    }
                })
                .catch(error=>{
                });
                //报名人员生源类型，社会招聘类型分布图
                this.$hrraxios.get(this.$api.console.getReportSourceAndOnJob,{params:{planId:DO.planId}})
                .then(response=> {
                    let data = response.data;
                    if (data.success == true) {
                    	data.data.forEach(e=>{
                    		if(e.gSourceType==""){
                    			e.gSourceType=e.oOnjobType;
                    		}
                    	})
                    	DO.SourceAndOnJobData.columns=Vuethis.SourceAndOnJobData.columns;
                        DO.SourceAndOnJobData.rows = data.data;
                    }else{
                    	Vuethis.$message({message:data.prompt,type:"error"});
                    }
                })
                .catch(error=>{
                });
			},
		},
		created(){
		}
	}
</script>
<style>
	.hrr-el-card{margin: 36px;}
	.console-show-plan h3{margin-bottom: 12px;}
</style>